import { render, staticRenderFns } from "./FormPagos.vue?vue&type=template&id=5ba88135&"
import script from "./FormPagos.vue?vue&type=script&lang=js&"
export * from "./FormPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports